import { useEffect, ReactNode } from "react";

import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

//redux
import { useAppSelector, useAppDispatch } from "~/hooks/redux";

type TLayoutProps = {
  children: ReactNode;
}

const Layout = ({ children }: TLayoutProps) => {
  const dispatch = useAppDispatch();

  const isPreloader = useAppSelector(state => state.Layout.isPreloader);
  const leftSideBarThemeImage = useAppSelector(state => state.Layout.leftSideBarThemeImage);
  const leftSideBarType = useAppSelector(state => state.Layout.leftSideBarType);
  const layoutWidth = useAppSelector(state => state.Layout.layoutWidth);
  const topbarTheme = useAppSelector(state => state.Layout.topbarTheme);
  const leftSideBarTheme = useAppSelector(state => state.Layout.leftSideBarTheme);

  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };

  /*
  layout  settings
  */

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    const status = document.getElementById("status");

    if (isPreloader === true) {
      if (preloader) preloader.style.display = "block";
      if (status) status.style.display = "block";

      setTimeout(() => {
        if (preloader) preloader.style.display = "none";
        if (status) status.style.display = "none";
      }, 2500);
    } else {
      if (preloader) preloader.style.display = "none";
      if (status) status.style.display = "none";
    }
  }, [isPreloader]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (leftSideBarThemeImage) {
      dispatch(changeSidebarThemeImage(leftSideBarThemeImage));
    }
  }, [leftSideBarThemeImage, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType, isMobile));
    }
  }, [leftSideBarType, isMobile, dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  return (
    <>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />
        <div className="main-content">{children}</div>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
